import './animation/getStarted';
import './animation/fadeInOnScroll';
